/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S2_I3_TextInputs */

const tr_kullanim_s2_i3_text = /** @type {(inputs: Kullanim_S2_I3_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trendyol, Shopify, Hepsiburada, n11, QNB eSolutions, Supabase vb. bağımsız sağlayıcılar`)
};

const en_kullanim_s2_i3_text = /** @type {(inputs: Kullanim_S2_I3_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`independent providers such as Trendyol, Shopify, Hepsiburada, n11, QNB eSolutions, Supabase`)
};

const de_kullanim_s2_i3_text = /** @type {(inputs: Kullanim_S2_I3_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`unabhängige Anbieter wie Trendyol, Shopify, Hepsiburada, n11, QNB eSolutions, Supabase`)
};

const ru_kullanim_s2_i3_text = /** @type {(inputs: Kullanim_S2_I3_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`независимые поставщики, такие как Trendyol, Shopify, Hepsiburada, n11, QNB eSolutions, Supabase`)
};

/**
* | output |
* | --- |
* | "independent providers such as Trendyol, Shopify, Hepsiburada, n11, QNB eSolutions, Supabase" |
*
* @param {Kullanim_S2_I3_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s2_i3_text = /** @type {((inputs?: Kullanim_S2_I3_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S2_I3_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s2_i3_text(inputs)
	if (locale === "de") return de_kullanim_s2_i3_text(inputs)
	if (locale === "ru") return ru_kullanim_s2_i3_text(inputs)
	return tr_kullanim_s2_i3_text(inputs)
});